var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('simple-header'),_c('router-view'),_c('simple-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }